export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--G.156dc834.png";